import { render, staticRenderFns } from "./CcIcon.vue?vue&type=template&id=318c9323&"
import script from "./CcIcon.vue?vue&type=script&lang=js&"
export * from "./CcIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports